export const PROGRAM = 'program';
export const AMOUNT = 'amount';
export const INVITECODE = 'inviteCode';
export const FULL_NAME = 'fullName';
export const USER_NAME = 'user_name';
export const EMAIL = 'email';
export const PHONE = 'phone';
export const PHONE_NUMBER = 'phone_number';
export const SELECTED_GENDER = 'selectedGender';
export const SELECTED_OCCUPATION = 'selectedOccupation';
export const CURRENT_CITY = 'currentCity';
export const WHATSAPP_INFO_STATUS = 'whatsappInfoStatus';
export const RECEIVE_UPDATES_INFO_STATUS = 'receiveUpdatesInfoStatus';
export const TEXT = 'text';
export const TEXTAREA = 'textarea';
export const CHECKBOX = 'checkbox';
export const SELECT = 'select';
export const ASYNC_SELECT = 'asyncSelect';
export const NUMBER = 'number';
export const LOCATION_AUTOFILL = 'locationAutoFill';
export const STATE_AND_DISTRICT = 'stateAndDistrict';
export const CHECKBOX_HEADING = 'checkboxHeading';
export const DATE_PICKER = 'datePicker';
export const CURRENT_STATE = 'currentState';
export const LAST_NAME = 'lastName';
export const DOB = 'dob';
export const DATE_OF_BIRTH = 'dateOfBirth';
export const CURRENT_DISTRICT = 'currentDistrict';
export const FULL_PAGE_TERMS_AND_CONDITIONS = 'termsAndConditions';
export const COLLEGE = 'college';
export const OTHER = 'other';
export const DEGREE = 'degree';
export const DEPARTMENT = 'department';
export const RADIO_GROUP = 'radioGroup';
export const MULTI_SELECT = 'multiSelect';
export const COUNTRY_CODE = 'countryCode';
export const COMPUTED = 'computed';
export const MINIMUM_AMOUNT_TO_BE_PAID = 'minimumAmountToBePaid';
export const CHECKBOX_GROUP = 'checkboxGroup';
export const NAME = 'name';
export const ARRAY_FIELD = 'array';
export const COUNTRY = 'country';
export const INVITE_CODE = 'inviteCode';
export const COUPON_CODE = 'couponCode';
export const CONTENT = 'content';
export const HEADING = 'heading';
export const TOTAL_AMOUNT_TO_BE_PAID = 'totalAmountToBePaid';
export const SELECT_A_DATE_TO_BOOK_A_SLOT = 'selectADateToBookASlot';
export const INFORMED_OTP_FIELD = 'informedOTPField';
export const PARAMS = 'params';
export const FILE_UPLOADER = 'fileUploader';
export const PAN_CARD_DETAILS_SECTION = 'panCardDetailsSection';
export const PINCODE = 'pincode';
export const DOCUMENT_UPLOAD = 'documentUpload';
export const SINGLE_DOCUMENT_UPLOAD = 'singleDocumentUpload';
export const MULTI_SELECT_CHECKBOX_GROUP = 'multiSelectCheckboxGroup';
export const MULTI_SELECT_CHECKBOX = 'multiSelectCheckbox';
export const WEBINAR_CYCLE = 'webinarCycle';
export const WEBINAR1_DATE_TIME = 'webinar1DateTime';
export const SLOT_OPTIONS_BASED_ON_DAY = 'slotOptionsBasedOnDay';
export const WEBINAR_DAY_WITH_SLOT = 'webinarDayWithSlot';
export const LIMITED_SLOTS = 'limitedSlotsField';
export const PUBLIC_REGISTRATION_FORM_INVITE_CODE =
  'publicRegistrationFormInviteCode';
export const FORM_VISIT_DATETIME = 'formVisitDateTime';
export const COUNTRY_ASYNC_SELECT = 'countryAsyncSelect';
export const STATE_ASYNC_SELECT = 'stateAsyncSelect';
export const DISTRICT_ASYNC_SELECT = 'districtAsyncSelect';
export const BRANCH_ASYNC_SELECT = 'branchAsyncSelect';
export const PREFERRED_LANGUAGE = 'preferredLanguage';
export const SLOT_SELECTION_FIELD = 'slotSelectionField';
export const SEARCHABLE_DROPDOWN = 'searchableDropdown';
export const CONDITIONALLY_DEPENDENT_FIELD = 'conditionallyDependentField';
export const BANNER = 'banner';
export const MULTIPLE_SELECT = 'multipleSelect';
export const FORM_FIELD_GROUP = 'formFieldGroup';
